import { useState } from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import Input from "../input/InputField";
import { EyeCloseIcon, EyeIcon } from "../../../icons";

interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  register?: UseFormRegisterReturn;
  placeholder?: string;
}

const PasswordInput = (props: PasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="relative">
      <Input
        type={showPassword ? "text" : "password"}
        placeholder={props.placeholder || "Enter password"}
        {...props.register}
      />
      <button
        type="button"
        onClick={() => setShowPassword(!showPassword)}
        className="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2"
      >
        {showPassword ? (
          <EyeIcon className="fill-gray-500 dark:fill-gray-400 size-5" />
        ) : (
          <EyeCloseIcon className="fill-gray-500 dark:fill-gray-400 size-5" />
        )}
      </button>
    </div>
  )
}

export default PasswordInput;
